  import { defineStore } from 'pinia';
  
  export const useFlyoutStore = defineStore('flyout', {
    state: () => ({
      isFlyoutOpen: false
    }),
    actions: {
      toggleFlyout() {
        this.isFlyoutOpen = !this.isFlyoutOpen;
      },
      openFlyout() {
        this.isFlyoutOpen = true;
      },
      closeFlyout() {
        this.isFlyoutOpen = false;
      },
    },
  });
